import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M9.001 3s-.001 0 0 0h-.002C4.972 3 1.516 5.47 0 9c1.516 3.531 4.973 6 9 6s7.484-2.469 9-6c-1.516-3.53-4.972-6-8.999-6zM9 13.8c-3.25 0-6.209-1.867-7.677-4.8a8.713 8.713 0 0 1 3.66-3.762A4.71 4.71 0 0 0 4.25 7.75a4.75 4.75 0 0 0 9.5 0c0-.925-.276-1.782-.733-2.512A8.697 8.697 0 0 1 16.677 9C15.209 11.933 12.25 13.8 9 13.8z" />
  </svg>
);

export default SvgComponent;
